import { Container } from "@mui/material";
import React from "react";
import logo from "assets/img/app-logo.png";
import "./navBar.css";
// import { appName } from "helpers";

function NavBar() {
    return (
        <>
            <nav>
                <Container>
                    <input id="nav-toggle" type="checkbox" />
                    <div className="logo">
                        <img src={logo} width={30} alt=""/>
                        <strong>
                            <a href="/">certify.social</a>
                        </strong>
                    </div>
                    <ul className="links">
                        <li><a href="/">home</a></li>
                        <li><a href="https://certify.social/organisations">certificates</a></li>
                        <li><a href="https://certify.social/auth/signin">login</a></li>
                        <li><a href="https://certify.social/schedule"><button>Get a Demo</button></a></li>
                    </ul>
                    {/* <ul className="links">
                        <li><a href="/">Home</a></li>
                        <li><a href="https://business.tokenlist.club/login">Business Account</a></li>
                        <li>
                            <a href="/auth/home">
                                <button>Wallet Login</button>
                            </a>
                        </li>
                    </ul> */}
                    <label htmlFor="nav-toggle" className="icon-burger">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </label>
                </Container>
            </nav>
        </>
    );
}

export default NavBar;
